import * as React from "react";
import PropTypes from "prop-types";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "./tooltip.jsx";
import { cn } from "../lib/utils.js";

/**
 * FastTooltip: Convenient single-wrapper Tooltip component with fast 100ms hover response.
 */
export function FastTooltip({
  children,
  content,
  side = "top",
  align = "center",
  delayDuration = 100,
  skipDelayDuration = 300,
  className,
  disabled = false,
}) {
  const [open, setOpen] = React.useState(false);

  if (!content) return children;

  const isEnabled = Boolean(content) && !disabled;

  return (
    <TooltipProvider
      delayDuration={delayDuration}
      skipDelayDuration={skipDelayDuration}
    >
      <Tooltip
        open={isEnabled ? open : false}
        onOpenChange={isEnabled ? setOpen : undefined}
      >
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        {isEnabled && (
          <TooltipContent
            side={side}
            align={align}
            className={cn("max-w-xs text-xs font-normal", className)}
          >
            {content}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}

FastTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node,
  side: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  align: PropTypes.oneOf(["start", "center", "end"]),
  delayDuration: PropTypes.number,
  skipDelayDuration: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FastTooltip;
